/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetHistoricalBalanceSnapshotsRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {GetHistoricalBalanceSnapshotsResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const getHistoricalBalanceSnapshots = (request: GetHistoricalBalanceSnapshotsRequest, options?: CashRequestOptions) => post<GetHistoricalBalanceSnapshotsRequest, GetHistoricalBalanceSnapshotsResponse>("/2.0/cash/get-historical-balance-snapshots", request, {...options, rejectOnError: true })